import { BlocksIconCircleFull } from 'blocks-nextjs/blocks-web-components/components/icon/icons/circle-full';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconCircleFull = createComponent({
  react: React,
  tagName: 'cat-icon-circle-full',
  elementClass: BlocksIconCircleFull
});
